import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { gluceraWelcomeCta } from "../../utils/gluceraTypography";
import BrandLogo from "../../components/BrandLogo";
import welcomeBg from "../../assets/homebg.png";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import "../../styles/globals.css";

const OnboardingWelcome = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Preserve family_invite_token if it exists
  const familyInviteToken = searchParams.get("family_invite_token");
  const queryString = familyInviteToken
    ? `?family_invite_token=${familyInviteToken}`
    : "";

  useEffect(() => {
    // Check if user has a valid access token (already logged in)
    const accessToken = localStorage.getItem("glucera_access_token");
    if (accessToken) {
      // User is already logged in, redirect to home
      navigate("/glucera" + GluceraNavigationRoutes.HOME + queryString, { replace: true });
      return;
    }

    // Check if onboarding is complete
    const onboardingComplete = localStorage.getItem(
      "glucera_onboarding_complete"
    );
    if (onboardingComplete === "true") {
      navigate("/glucera" + GluceraNavigationRoutes.HOME + queryString);
    }

    // Override body background for this page
    document.body.style.background = "transparent";
    document.body.style.backgroundColor = "transparent";

    return () => {
      // Restore default background when leaving
      document.body.style.background = "";
      document.body.style.backgroundColor = "";
    };
  }, [navigate, queryString]);

  return (
    <div className="fixed inset-0 w-screen overflow-hidden">
      <div className="relative mx-auto flex h-full w-full max-w-md flex-col overflow-hidden bg-black">
        {/* Blurred Background Image */}
        <div
          className="absolute inset-0 scale-105 bg-cover bg-center bg-no-repeat blur-sm"
          style={{ backgroundImage: `url(${welcomeBg})` }}
        />

        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/50" />

        {/* Content Container with proper spacing */}
        <div className="relative z-10 flex h-full flex-col px-4 py-6">
          {/* Top Spacer */}
          <div className="flex-none" style={{ height: "10vh" }} />

          {/* Main Content - Centered */}
          <div className="flex flex-1 flex-col items-center justify-center space-y-4 text-center">
            <BrandLogo variant="hero" />

            {/* Description */}
            <div className="px-4 py-3">
              <p className="mx-auto max-w-xs text-sm font-semibold leading-relaxed text-white drop-shadow-md">
                Track meals with AI, monitor fitness, and achieve your health
                goals with personalized insights
              </p>
            </div>
          </div>

          {/* CTA - Fixed at bottom */}
          <div className="flex-none space-y-2 pb-6">
            <Button
              onClick={() =>
                navigate(
                  "/glucera" + GluceraNavigationRoutes.ONBOARDING_LOGINPAGE + queryString
                )
              }
              className={gluceraWelcomeCta}
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingWelcome;
